import classNames from 'classnames';
import Image, { ImageProps } from 'components/gruenland/atoms/image';
import Link from 'components/gruenland/atoms/link';
import { GruenlandJuniorHeaderLogo } from 'components/svgr/GruenlandJuniorHeaderLogo';
import { GruenlandJuniorWhiteLogo } from 'components/svgr/GruenlandJuniorWhiteLogo';
import { TYPOGRAPHY_HERO_TITLE } from 'lib/typography';
import { Reference } from 'types/reference';

export type Module01SlideProps = {
  overTitle?: string;
  title: string;
  media: ImageProps;
  juniorLogo?: boolean;
  ctaLabel?: string;
  ctaLink?: Reference;
};

const Module01Slide: React.FC<Module01SlideProps> = ({ overTitle, title, media, juniorLogo, ctaLabel, ctaLink }) => {
  return (
    <>
      <div className="relative h-[711px] w-full md:aspect-video md:h-auto">
        {media.media?.resourceType === 'image' && <Image {...media} alt={media.alt} className="object-cover" fill />}
        {media.media?.resourceType === 'video' && media?.media?.file && (
          <video autoPlay loop muted className="absolute left-0 top-0 size-full object-cover">
            <source src={media?.media?.file} type="video/mp4" />
          </video>
        )}
        <div className="hidden items-center md:absolute md:inset-0 md:grid">
          <div className="p-[60px]">
            <span className="mb-5 text-center text-[16px]/[20px] font-medium uppercase text-white lg:text-left">
              {overTitle}
            </span>
            <h2 className={classNames(TYPOGRAPHY_HERO_TITLE, 'mb-5 text-center text-white md:text-left')}>{title}</h2>
            {ctaLink && (
              <Link link={ctaLink} variant="buttonPrimaryNegative">
                {ctaLabel}
              </Link>
            )}
          </div>
        </div>
        {juniorLogo && (
          <div className="absolute bottom-[138px] right-[60px] hidden md:block">
            <GruenlandJuniorWhiteLogo />
          </div>
        )}
      </div>
      <div className="flex flex-col items-center p-[30px] md:hidden">
        {juniorLogo && <GruenlandJuniorHeaderLogo width={118} height={40} className="mb-4 md:hidden" />}
        <span className="mb-5 text-[12px]/[15px] font-medium uppercase">{overTitle}</span>
        <h2 className={classNames(TYPOGRAPHY_HERO_TITLE, 'mb-5 text-neutrals-black')}>{title}</h2>
        <Link link={ctaLink} variant="buttonPrimaryGreen">
          {ctaLabel}
        </Link>
      </div>
    </>
  );
};

export default Module01Slide;
